import apiClient from './client'
import {
  AvatarCandidate,
  toApiError,
} from '../pages/register/api/registration.api'

/** The signed-in user's security avatar. */
export const securityAvatarApi = {
  /** Candidates whose tokens only this user can save. */
  getCandidates: async (): Promise<{ candidates: AvatarCandidate[] }> => {
    try {
      const res = await apiClient.get<{
        data: { candidates: AvatarCandidate[] }
      }>('/users/me/security-avatar/candidates')
      return res.data.data
    } catch (error) {
      throw toApiError(error)
    }
  },

  save: async (securityAvatarToken: string): Promise<void> => {
    try {
      await apiClient.put('/users/me/security-avatar', { securityAvatarToken })
    } catch (error) {
      throw toApiError(error)
    }
  },
}
